import React, { PropTypes } from 'react';
import { v4 } from 'node-uuid';
import classnames from 'classnames';

const Benefits = ({ benefits, title, className, background }) => (
  <section className={classnames('block block-why', className, background)}>
    <div className="row columns">
      <div className="block-header">
        <h2>{title}</h2>
      </div>
    </div>
    <div className="row align-spaced">
      {benefits.map(benefit => (<div className="small-16 large-6 columns" key={v4()}>
        <div className={classnames("row content-block", { "text-center": benefit.image })}>
          <div className="columns medium-16">
            { !!benefit.image && <img src={benefit.image} alt={benefit.title} /> }
            <h3>{benefit.title}</h3>
            <p dangerouslySetInnerHTML={{ __html: benefit.description_html }} />
          </div>
        </div>
      </div>))}
    </div>
  </section>
);

Benefits.propTypes = {
  benefits: PropTypes.arrayOf(PropTypes.shape({
    image: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
  })),
  title: PropTypes.string,
  className: PropTypes.string,
  background: PropTypes.string
};

export default Benefits;



// WEBPACK FOOTER //
// ./landing_pages/components/benefits.jsx